import { Business, Category } from './types';

export const CATEGORIES: Category[] = [
  {
    id: 'Dance & Fitness',
    title: 'Dance & Fitness',
    description: 'Find your rhythm with local instructors.',
    image: 'https://images.unsplash.com/photo-1508700115892-45ecd05ae2ad?auto=format&fit=crop&q=80&w=800',
    icon: 'Music'
  },
  {
    id: 'Events',
    title: 'Events',
    description: 'Speed dating, workshops, and networking.',
    image: 'https://images.unsplash.com/photo-1511795409834-ef04bbd61622?auto=format&fit=crop&q=80&w=800',
    icon: 'Calendar'
  },
  {
    id: 'Local Food & Home Bakers',
    title: 'Food & Baking',
    description: 'Delicious treats from home kitchens.',
    image: 'https://images.unsplash.com/photo-1555507036-ab1f4038808a?auto=format&fit=crop&q=80&w=800',
    icon: 'Utensils'
  },
  {
    id: 'Local Services',
    title: 'Local Services',
    description: 'Photographers, DJs, and home help.',
    image: 'https://images.unsplash.com/photo-1521791136064-7986c2923216?auto=format&fit=crop&q=80&w=800',
    icon: 'Camera'
  },
  {
    id: 'Made in Windsor',
    title: 'Made in Windsor',
    description: 'Support local craftspeople and makers.',
    image: 'https://images.unsplash.com/photo-1459411552884-841db9b3cc2a?auto=format&fit=crop&q=80&w=800',
    icon: 'Hammer'
  },
  {
    id: 'Other',
    title: 'Other',
    description: 'Explore more local independent offerings.',
    image: 'https://images.unsplash.com/photo-1517524206127-48bbd363f3d7?auto=format&fit=crop&q=80&w=800',
    icon: 'Sparkles'
  }
];

export const BUSINESSES: Business[] = [
  {
    id: '1',
    name: 'Dance Academy',
    slug: 'dance-academy',
    category: 'Dance & Fitness',
    description: 'Premium dance classes for all styles and levels. Specializing in Salsa, Bachata, Ballet, Hip-Hop, and more.',
    image: 'https://images.unsplash.com/photo-1547153760-18fc86324498?auto=format&fit=crop&q=80&w=800',
    location: 'Windsor, ON',
    tags: ['Salsa', 'Bachata', 'Ballet', 'Hip-Hop', 'Fitness'],
    featured: true,
    comingSoon: true
  },
  {
    id: '2',
    name: 'The Sweet Spot Bakery',
    slug: 'homemade-cookies-windsor',
    category: 'Local Food & Home Bakers',
    description: 'Handcrafted cookies and custom cakes made with love in Windsor.',
    image: 'https://images.unsplash.com/photo-1495147466023-ac5c588e2e94?auto=format&fit=crop&q=80&w=800',
    location: 'Windsor, ON',
    tags: ['Bakery', 'Cookies', 'Custom Cakes'],
    featured: true,
    comingSoon: true
  },
  {
    id: '3',
    name: 'RG Connections',
    slug: 'rg-connections',
    category: 'Events',
    description: 'Intentional speed-friending, speed-dating, and social events in Windsor-Essex. Meet real people face-to-face and make lasting connections.',
    image: '/rg_connections_full.jpg',
    location: 'Windsor, ON',
    tags: ['Speed Dating', 'Speed Friending', 'Social Events', 'Community'],
    featured: true,
    comingSoon: false
  }
];
